import { Component } from '@angular/core';

@Component({
  selector: 'stars-guest-anatomy',
  templateUrl: './guest-anatomy.component.html',
  styleUrls: ['./guest-anatomy.component.scss']
})
export class GuestAnatomyComponent {}
